const TYPE = "(?:case|appartamenti|ville|attici|loft|uffici|locali-commerciali|box-auto)";
const FEATURE_TYPE = "(?:case|appartamenti|ville|attici|loft)";
const FEATURE = "(?:terrazzo|giardino|ascensore|aria-condizionata|arredate|posto-auto|riscaldamento-autonomo)";
const ROOMS = "(?:bilocali|trilocali|quadrilocali)";
const CITY = "[a-z0-9]+(?:-[a-z0-9]+)*";

const SEO_PATTERNS = [
    new RegExp(`^${TYPE}-(?:vendita|affitto)-${CITY}$`, "i"),
    new RegExp(`^${FEATURE_TYPE}-con-${FEATURE}-${CITY}$`, "i"),
    new RegExp(`^${ROOMS}-(?:vendita|affitto)-${CITY}$`, "i"),
    new RegExp(`^immobili-commerciali-${CITY}$`, "i"),
];

export const isSeoLandingSlug = (slug = "") => SEO_PATTERNS.some((pattern) => pattern.test(slug));